import {
  Component,
  OnInit,
  Input,
  HostBinding,
  Inject,
  Output,
  EventEmitter
} from '@angular/core';
import { Router } from '@angular/router';
import { PostItem, PRODUCT_TYPES } from '@apps/api-interfaces';
import { StorageService, ENV_VARS, ScrollService } from '@apps/ui';

@Component({
  selector: 'sc-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  @Input() data: PostItem;
  @Input() static: boolean;

  timeout: boolean;

  @HostBinding('class') get className() {
    const items = [(this.data && this.data.extra) || 'top'];
    if (this.static) {
      items.push('static');
    }

    return items.join(' ');
  }

  @HostBinding('attr.disabled') get attrHidden() {
    return ['/kalkulator/podsumowanie'].some(
      e => this.router.url.indexOf(e) > -1
    );
  }

  @HostBinding('attr.button-disabled') get attrButtonDisabled() {
    return ['/kalkulator/detale', '/kalkulator/buttonDisabled'].some(
      e => this.router.url.indexOf(e) > -1
    );
  }

  @HostBinding('attr.blog') get attrBlog() {
    return ['/artykuly'].some(e => this.router.url.indexOf(e) > -1);
  }

  @Output() onclose = new EventEmitter<string>();

  showMore: boolean;

  get currentProduct() {
    return PRODUCT_TYPES.find(e => this.router.url.split('/')[1] === e.id);
  }

  constructor(
    @Inject(ENV_VARS) public env,
    private storage: StorageService,
    private router: Router,
    private scroll: ScrollService
  ) {}

  ngOnInit() {}

  setHidden() {
    this.storage.setItem(`alert_${this.data.slug}`, '1');
    this.onclose.emit(this.data.slug);
  }

  toggleShowMore(event: Event) {
    event.preventDefault();
    this.showMore = !this.showMore;
  }

  goToLink() {
    if (this.data.extra3) {
      this.router.navigateByUrl(this.data.extra3);
      setTimeout(() => {
        this.scroll.scrollByQueryParams(-60, this.data.extra3);
      }, 300);
    }
  }

  onTimeout(e?: boolean) {
    this.timeout = !!e;
  }
}
